__turbopack_context__.v({
  "active": "pagination-module-scss-module__nO6MwG__active",
  "noClick": "pagination-module-scss-module__nO6MwG__noClick",
  "pagination": "pagination-module-scss-module__nO6MwG__pagination",
  "paginationItem": "pagination-module-scss-module__nO6MwG__paginationItem",
  "paginationList": "pagination-module-scss-module__nO6MwG__paginationList",
});
